import PublishedHeader from './PublishedHeader';
import Container from './PublishedHeader.container';

export default Container(PublishedHeader);
